import script from "./ServiceStatusTabs.vue?vue&type=script&setup=true&lang=ts"
export * from "./ServiceStatusTabs.vue?vue&type=script&setup=true&lang=ts"

import "./ServiceStatusTabs.vue?vue&type=style&index=0&id=3491dd52&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3491dd52"]])

export default __exports__